import { render, staticRenderFns } from "./SalaMonitoramento.vue?vue&type=template&id=3ed9446b&scoped=true"
import script from "./SalaMonitoramento.vue?vue&type=script&lang=js"
export * from "./SalaMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./SalaMonitoramento.vue?vue&type=style&index=0&id=3ed9446b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9446b",
  null
  
)

export default component.exports